import ru from 'vuetify/lib/locale/ru'

export default {
  account: 'аккаунт',
  accountNotActive: 'аккаунт отключен',
  accounts: 'аккаунты',
  active: 'активен',
  add: 'добавить',
  addAccount: 'добавить аккаунт',
  addSelected: 'добавить выбранное',
  address: 'адрес',
  additionalLanguage: 'дополнительный язык',
  administration: 'администрирование',
  all: 'все',
  allBeverages: 'все напитки',
  allWeek: 'вся неделя',
  any: 'любой',
  apiDocs: 'API документация',
  apiKeys: 'API ключи',
  apply: 'применить',
  available: 'доступно',
  availableModels: 'доступно моделей',
  back: 'назад',
  backToLoginPage: 'вернуться на страницу входа',
  beverage: 'напиток',
  beverages: 'напитки',
  beverageSales: 'продажи по напиткам',
  brand: 'бренд',
  brands: 'бренды',
  businessHours: 'время работы',
  byCities: 'по городам',
  byClients: 'по клиентам',
  byDays: 'по дням',
  byModels: 'по моделям',
  cancel: 'отмена',
  cancelDelete: 'отменить удаление?',
  canceled: 'отмененные',
  cantDeleteFirstDeleteRelations:
    'удаление не разрешено, сначала удалите связанные объекты',
  cantDeleteDefaultValue: 'нелзя удалить значение по умолчанию',
  cause: 'причина',
  causeFaultGroup: 'группа причин неисправностей',
  causeFaultGroups: 'группы причин неисправностей',
  causeFaults: 'причины неисправностей',
  causeGroups: 'группы причин',
  causes: 'причины',
  changePassword: 'изменить пароль',
  cities: 'города',
  city: 'город',
  client: 'контрагент',
  clientFault: 'причина вызова',
  clientFaultGroup: 'группа причины вызова',
  clientFaultGroups: 'группы причин вызова',
  clientFaults: 'причины вызова',
  clients: 'контрагенты',
  clone: 'клонировать',
  close: 'закрыть',
  closed: 'закрыто',
  code: 'код',
  color: 'Цвет',
  comment: 'комментарий',
  taskComment: 'комментарий к задаче',
  completedDate: 'дата завершения',
  connectionLost: 'соединение потеряно',
  connectionRestored: 'соединение восстановлено',
  confirmDelete: 'вы уверены, что хотите удалить этот элемент?',
  confirmOrderCancel:
    'вы действительно хотите отменить наряд-заказ? Это действие не возможно будет отменить',
  confirmPassword: 'подтвердите пароль',
  connectServerError: 'ошибка подключения к серверу',
  contactPerson: 'контактное лицо',
  contactPersons: 'контактные лица',
  contract: 'договор',
  contractor: 'исполнитель',
  contracts: 'договоры',
  controlTechConditions: 'контроль тех. условий',
  counter: 'счетчик',
  counterFrom: 'счетчик от',
  counterTo: 'счетчик до',
  countries: 'страны',
  country: 'страна',
  create: 'создать',
  createdBasedOrder: 'создано на основании наряд-заказа',
  createdDate: 'дата создания',
  createdOrder: 'создан наряд-заказ',
  dashboard: 'панель управления',
  date: 'дата',
  dateEnd: 'дата окончания',
  dateStart: 'дата начала',
  days: 'дней',
  daysDot: 'д.',
  decisionMakerName: 'имя ЛПР',
  decisionMakerPhone: 'телефон ЛПР',
  default: 'по умолчанию',
  defaultLocationBusinessHours: 'время работы локаций по умолчанию',
  defaultPageTitle: 'SERVICE DESK',
  defaultReactionTime: 'время реакции по умолчанию',
  defaultSolutionTime: 'время решения по умолчанию',
  delete: 'удалить',
  deleteAccount: 'удалить аккаунт',
  demo: 'демо',
  none: 'нет',
  deleteUserAccount:
    'аккаунт будет удален, пользователь больше не сможет войти в систему.',
  description: 'описание',
  details: 'реквизиты',
  disableAllSorts: 'отключить все сортировки',
  distance: 'расстояние',
  distanceFromService: 'удаленность от СЦ',
  document: 'документ',
  download: 'скачать',
  edit: 'редактировать',
  editDate: 'изменить дату',
  editingWillBeAwailableOn: 'редактирование будет доступно',
  employee: 'сотрудник',
  eqTypes: 'типы оборудования',
  equipment: 'оборудование',
  equipments: 'оборудование',
  error: 'ошибка',
  errorCreatingRepeatedOrder: 'ошибка создания повторяющегося наряд-заказа',
  errorLoadingData: 'ошибка загрузки данных',
  errorLoadingFromServer: 'ошибка при загрузке с сервера',
  every: 'каждые',
  fault: 'неисправность',
  faultCode: 'код неисправности',
  faultGroup: 'группа неисправностей',
  faultGroups: 'группы неисправностей',
  faults: 'неисправности',
  filter: 'фильтр',
  filters: 'фильтры',
  firstDeleteAllRelations: 'сначала вам нужно удалить все связанные элементы',
  firstName: 'имя',
  forgotPassword: 'забыли пароль?',
  from: 'начало',
  fromClients: 'от клиентов',
  generalInfo: 'общая информация',
  globals: 'глобальные',
  gps: 'gps',
  group: 'группа',
  groups: 'группы',
  hide: 'скрыть',
  home: 'главная',
  hours: 'часов',
  hoursDot: 'ч.',
  identFaultGroups: 'группы выявленных неисправностей',
  identFaults: 'выявленные неисправности',
  idents: 'выявленные',
  ingredient: 'ингредиент',
  ingredients: 'ингредиенты',
  instruction: 'инструкция',
  isRepeat: 'повторяется',
  key: 'ключ',
  km: 'км',
  language: 'язык',
  lastName: 'фамилия',
  loading: 'загрузка',
  placement: 'местоположение',
  places: 'местоположения',
  location: 'локация',
  locations: 'локации',
  login: 'вход',
  loginIncorect: 'не верный логин или пароль',
  mailingList: 'емайлы для рассылки',
  managerEmail: 'email менеджера',
  managerName: 'имя менеджера',
  managerPhone: 'телефон менеджера',
  maximum: 'максимум',
  maxReactionTimeByContract: 'макс. время реакции по контракту',
  maxSolutionTimeByContract: 'макс. время решения по договору',
  maxTimeOfWorkByContract: 'макс. время работы по договору',
  maxWorkTime: 'максимальное время работы',
  middleName: 'отчество',
  minimum: 'минимум',
  minutes: 'минут',
  minutesDot: 'мин.',
  mode: 'режим',
  model: 'модель',
  models: 'модели',
  month: 'месяц',
  months: {
    jan: 'Янв',
    feb: 'Фев',
    mar: 'Мар',
    apr: 'Апр',
    may: 'Май',
    jun: 'Июн',
    jul: 'Июл',
    aug: 'Авг',
    sep: 'Сен',
    oct: 'Окт',
    nov: 'Ноя',
    dec: 'Дек'
  },
  name: 'имя',
  new: 'новый',
  newPassword: 'новый пароль',
  nextTry: 'следующая попытка',
  no: 'нет',
  noData: 'нет данных',
  noSalesForPeriod: 'за данный период продаж нет',
  notActive: 'не активен',
  notAssigned: 'не назначено',
  notCanceled: 'не отмененные',
  notFound: 'не найдено',
  notSpecified: 'не указано',
  notFoundDescription: 'ресурс мог быть перемещен или удален',
  notReceiveCode: 'не получили код?',
  notRepeat: 'не повторяется',
  notification: 'уведомление',
  notifications: 'уведомления',
  notificationTimeTaked: 'время уведомления до назначен',
  notificationTimeReacted: 'время уведомления до реакции',
  notificationTimeResolved: 'время уведомления до  решения ',
  now: 'сейчас',
  number: 'номер',
  object: 'объект',
  objects: 'объекты',
  onlyActive: 'только активные',
  onlyByZone: 'только из зон',
  onlyTheir: 'только свои',
  opened: 'открыто',
  order: 'наряд-заказ',
  orderBusinessHours: 'время приёма наряд-заказов',
  orderCancel: 'отмена наряд-заказа',
  orderCanceled: 'отменён',
  orderCreatorDetails: 'подробности наряд-заказа',
  orderCreatorName: 'имя создателя наряд-заказа',
  orderCreatorPhone: 'телефон создателя наряд-заказа',
  orderCreatorType: 'тип создателя наряд-заказа',
  orderEditRules: 'правила редактирования наряд-заказа',
  orderStatus: 'статус наряд-заказа',
  orderStatuses: 'статусы наряд-заказов',
  orderStatusHistory: 'история статусов наряд-заказов',
  orderTriggerHint:
    'новый наряд-заказ будет создан при переходе текущего в этот статус',
  orderType: 'тип наряд-заказа',
  orderTypes: 'типы наряд-заказов',
  orders: 'наряд-заказы',
  totalOrders: 'всего наряд-заказов',
  ordersInProgress: 'в работе',
  ordersClosed: 'закрыто',
  ordersByEquipment: 'наряд-заказы по оборудованию',
  ordersCount: 'количество наряд-заказов',
  completedOrders: 'выполненные наряд-заказы',
  completedOrdersCount: 'количество выполненных наряд-заказов',
  completedOnTime: 'выполненные в срок',
  overdueOrdersCount: 'количество просроченных наряд-заказов',
  overdueReaction: 'просроченные по реакции',
  overdueSolution: 'просроченные по решению',
  completed: 'выполненные',
  inProgress: 'в работе',
  otherFault: 'другая причина вызова',
  otherM: 'другой',
  others: 'других',
  otherW: 'другая',
  owner: 'владелец',
  owners: 'владельцы',
  part: 'запчасть',
  partGroup: 'группа запчастей',
  partGroups: 'группы запчастей',
  parts: 'запчасти',
  password: 'пароль',
  period: 'период',
  permissions: 'разрешения',
  phone: 'телефон',
  phones: 'телефоны',
  pressure: 'давление',
  products: 'продукты',
  quantity: 'количество',
  range: 'диапазон',
  recipe: 'рецепт',
  recipes: 'рецепты',
  noRecipe: 'рецепт не назначен',
  recipeRequired: 'для создания напитка необходимо добавить хотя бы один ингредиент',
  addIngredient: 'добавить ингредиент',
  manageRecipe: 'управление рецептом',
  reaction: 'реакция',
  reactionDate: 'дата начала работ',
  reactionTime: 'время реакции',
  reactionTimer: 'таймер реакции',
  region: 'область',
  regions: 'области',
  removeSelected: 'удалить выбранное',
  repeat: 'повторять',
  repeatedOrder: 'повторяющийся наряд-заказ',
  resend: 'отправить еще раз',
  reset: 'сбросить',
  resetSort: 'сбросить сортировку',
  retry: 'повторить',
  role: 'роль',
  roles: 'роли',
  sales: 'продажи',
  salesByBeverages: 'продажи по напиткам',
  salesByClients: 'продажи по клиентам',
  salesByLocations: 'продажи по локациям',
  salesByMonth: 'продажи за месяц',
  salesByPeriod: 'продажи за период',
  salesByWeek: 'продажи за неделю',
  salesByWeekDays: 'продажи по дням недели',
  salesByHours: 'продажи по часам',
  salesByYear: 'продажи за год',
  save: 'сохранить',
  savePassword: 'сохранить пароль',
  scanQrForServiceRequest:
    'Отсканируйте этот QR для создания наряд-заказа на ремонт',
  search: 'поиск',
  selectAll: 'выбрать все',
  selectDaysOfTheWeek: 'выберите дни недели',
  sendCode: 'отправить код',
  serialNumber: 'серийный номер',
  serverError: 'ошибка сервера',
  serverValidationError: 'ошибка валидации',
  serviceCenter: 'сервисный центр',
  settings: 'настройки',
  shortName: 'имя',
  show: 'показать',
  showAllColumns: 'показать все колонки',
  showLessColumns: 'скрыть колонки',
  showMore: 'показать еще',
  showTelemetry: 'показать телеметрию',
  sla: 'соглашение об уровне обслуживания',
  solution: 'решение',
  solutionDate: 'дата окончания работ',
  solutionTime: 'время решения',
  solutionTimer: 'таймер решения',
  sort: 'сортировка',
  startTravelTimer: 'запустить таймер в пути',
  sortDefault: 'сортировка по умолчанию',
  staff: 'сотрудник',
  staffs: 'сотрудники',
  state: 'состояние',
  status: 'состояние',
  statuses: 'состояния',
  suspended: 'приостановлен',
  stopNotifications: 'остановить уведомления',
  stopReactionTimer: 'остановить таймер реакции',
  stopSolutionTimer: 'остановить таймер решения',
  stopTravelTimer: 'остановить таймер в пути',
  superAdmin: 'супер-админ',
  tableWidth: 'ширина таблицы',
  telegram: 'телеграм',
  telemetry: 'телеметрия',
  time: 'время',
  timeByFaultType: 'время по типу неисправности',
  timeDefault: 'время по умолчанию',
  timeOfWork: 'время работы',
  title: 'название',
  to: 'окончание',
  toRecoverPassword:
    'чтобы восстановить пароль, введите свой номер телефона, и мы пришлем вам SMS с кодом восстановления.',
  total: 'всего',
  totalClients: 'всего клиентов',
  totalLocations: 'всего локаций',
  totalSales: 'общие продажи',
  transitionFrom: 'переход с',
  transitionTo: 'переход на',
  travelTime: 'время в пути',
  trigger: 'триггер',
  type: 'тип',
  types: 'типы',
  unit: 'единица измерения',
  units: 'единицы измерения',
  unselectAll: 'снять все',
  user: 'пользователь',
  userName: 'имя пользователя',
  users: 'пользователи',
  verifyCode: 'проверить код',
  video: 'видео',
  voltage: 'напряжение',
  waitLoadingFromServer: 'ожидание загрузки с сервера',
  warning: 'предупреждение',
  week: 'неделя',
  weeks: 'недели',
  withoutAccount: 'без аккаунта',
  work: 'работа',
  workGroups: 'группы работ',
  works: 'работы',
  workTime: 'время работы',
  workType: 'тип работы',
  workTypes: 'типы работ',
  year: 'год',
  yes: 'да',
  zone: 'зона',
  zoneBy: 'зона по',
  zones: 'зоны',
  zonesFilterMode: 'режим фильтра зоны:',
  validation: {
    alpha: 'должен(но) содержать только буквы',
    alreadyTaked: 'уже занято',
    alreadyStaff: 'другой исполнитель уже указан, перезагрузите страницу',
    brand: {
      notActive: 'бренд не активен'
    },
    client: {
      notActive: 'клиент не активен'
    },
    contract: {
      notActive: 'не найден активный договор',
      notActiveOrExpired: 'не найден активный договор или срок договора истек'
    },
    email: 'должен быть действительный адрес электронной почты',
    emails: 'вводите электронную почту через запятую',
    eqType: {
      notActive: 'тип оборудования не активен'
    },
    equipment: {
      notActive: 'оборудование не активно'
    },
    integer: 'должно быть целым числом',
    ipVsPort: 'должен быть допустимым ip и портом: xxx.xxx.xxx.xxx:xxxxx',
    isChangedValue: 'выберите новое значение',
    length: 'должен иметь {n} символ | должен иметь {n} символов',
    location: {
      notActive: 'локация не активна'
    },
    maxLength: 'макс. количество символов: {n}',
    maxValue: 'максимальное значение - {n}',
    minLength: 'мин. количество символов: {n}',
    minValue: 'минимальное значение - {n}',
    model: {
      notActive: 'модель не активна',
      noContract:
        'не найден активный договор для данной модели оборудования или срок договора истек'
    },
    numeric: 'должно быть числом',
    password: {
      hasLowerCase: 'строчную букву',
      hasNumbers: 'цифру',
      hasSymbol: 'символ',
      hasUpperCase: 'заглавную букву',
      minLength: 'мин. 8 символов',
      mustContain: 'пароль должен содержать:'
    },
    passwordMismatch: 'пароли не совпадают',
    phone: 'должен быть действительным телефоном: +XXXXXXXXXXXX',
    repeatedOrderDate:
      'внимание! Дата следующего наряд-заказа больше даты окончания договора на обслуживание оборудования, наряд-заказ может быть не создан!',
    required: 'не может быть пустым',
    requiredOneOf: 'необходимо заполнить хотя бы одно из полей',
    retry: 'повторить',
    sameAs: 'не совпадает с: {n}',
    url: 'должна быть действующая URL-ссылка',
    ingredientsInUse: 'Ингредиент {ingredients} используется в существующем оборудовании. Вы хотите удалить ингредиент из всего оборудования ({count} шт)? | Ингредиенты {ingredients} используются в существующем оборудовании. Вы хотите удалить ингредиенты из всего оборудования ({count} шт)?',
    confirmRemoval: 'Подтвердить удаление',
    cancelRemoval: 'Отменить'
  },
  weekDays: {
    sunday: 'воскресенье',
    monday: 'понедельник',
    tuesday: 'вторник',
    wednesday: 'среда',
    thursday: 'четверг',
    friday: 'пятница',
    saturday: 'суббота',
    holiday: 'выходной',
    sun: 'вc',
    mon: 'пн',
    tue: 'вт',
    wed: 'ср',
    thu: 'чт',
    fri: 'пт',
    sat: 'сб'
  },
  $vuetify: ru
}
